// Shared form primitives for the admin editor sections
import { Plus, Trash2 } from "lucide-react";

export function Field({ label, hint, children }) {
  return (
    <label className="block">
      <span className="block text-xs tracking-[0.2em] uppercase text-onyx/60 mb-2">{label}</span>
      {children}
      {hint && <span className="block mt-1 text-xs text-onyx/40">{hint}</span>}
    </label>
  );
}

export function TextInput({ value, onChange, placeholder, testId }) {
  return (
    <input
      data-testid={testId}
      type="text"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full px-3 py-2.5 border border-border bg-white text-onyx focus:outline-none focus:border-gold transition-colors text-sm"
    />
  );
}

export function NumberInput({ value, onChange, testId }) {
  return (
    <input
      data-testid={testId}
      type="number"
      value={value ?? 0}
      onChange={(e) => onChange(Number(e.target.value))}
      className="w-full px-3 py-2.5 border border-border bg-white text-onyx focus:outline-none focus:border-gold transition-colors text-sm"
    />
  );
}

export function TextArea({ value, onChange, rows = 4, testId, placeholder }) {
  return (
    <textarea
      data-testid={testId}
      rows={rows}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full px-3 py-2.5 border border-border bg-white text-onyx focus:outline-none focus:border-gold transition-colors text-sm leading-relaxed font-sans"
    />
  );
}

export function SectionCard({ title, children }) {
  return (
    <div className="bg-white border border-border p-6 sm:p-8">
      {title && <h3 className="font-serif text-2xl text-onyx mb-6">{title}</h3>}
      {children}
    </div>
  );
}

export function ListAddBtn({ onClick, label, testId }) {
  return (
    <button
      data-testid={testId}
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-2 px-4 py-2 border border-onyx text-xs tracking-[0.2em] uppercase hover:bg-onyx hover:text-alabaster transition-colors"
    >
      <Plus size={14} /> {label}
    </button>
  );
}

export function ListRemoveBtn({ onClick, testId }) {
  return (
    <button
      data-testid={testId}
      type="button"
      onClick={onClick}
      className="text-onyx/40 hover:text-destructive transition-colors p-1"
      aria-label="Remover"
    >
      <Trash2 size={16} />
    </button>
  );
}
